import { render } from "./ThePatientDocumentUpload.vue?vue&type=template&id=a02a34ac"
import script from "./ThePatientDocumentUpload.vue?vue&type=script&lang=js"
export * from "./ThePatientDocumentUpload.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__